import request from '@/utils/request'
export function getToken(visitNo,patientNo) {
  return request({
    url: `/feature/visitToken?visitNo=${visitNo}&patientNo=${patientNo}`,
    method: 'get',
  })
}